import React, { PureComponent } from "react";
import {
	Form,
	Select,
	InputNumber,
	Checkbox,
	Button,
	Divider,
	message,
	Input,
	Col,
} from "antd";
import {
	receiveMessage,
	sendMessage,
	initWebSocket,
} from "../../../request/websocket";
import { remoteHospitalList } from "@/request/api";
import { requestErrorLog } from '@/common/util'

const { Option } = Select;
const FormItem = Form.Item;
class settingConfig extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			msgType: ["有新会诊到达消息", "会诊完成消息"],
			apply: "1",
			consulation: "1",
			printingType: "会诊医院",
			refresh: "2",
			hospitalNumber: "病历号",
			hospitalDateTime: "申请日期",
			signatureType: "电子签名",
			uploadList: new Map(),
			fileTree: "",
			fileOutTree: "",
			IPAddress: "",
			IPPort: "",
			equipmentList: [],
			EEG_FILE_PATH: "",
			equipmentValue: "",
			referralApplyTime: "1",
			referralConsultTime: "1",
			showTranquillizationBlood: false,
			remoteApplyList: [
				{ label: '静息心电', value: 'ECG' },
				{ label: '动态心电', value: 'HOLTER' },
				{ label: '动态血压', value: 'BLOOD' }
			],
			consulationList: [],
		};
	}

	async componentDidMount() {
		await initWebSocket();
		this.getConsulationHospital()
		const data = JSON.parse(localStorage.getItem("settingValues"));
    console.log(data,'查到的参数')
		if (data) {
			this.setState({
				waitImproved: data.waitImproved ? data.waitImproved : false,
				automaticApply: this.state.automaticApplyCode ? this.state.automaticApplyCode : data.automaticApply,
				automaticConsult: this.state.automaticConsultCode ? this.state.automaticConsultCode : data.automaticConsultName,
				automaticCompleteConsult: this.state.automaticCompleteCode ? this.state.automaticCompleteCode : data.automaticCompleteConsult,
				msgType: data.msgType
					? data.msgType
					: ["有新会诊到达消息", "会诊完成消息"],
				apply: data.apply ? data.apply : "1",
				consulation: data.consulation ? data.consulation : "1",
				printingType: data.printingType ? data.printingType : "申请医院",
				refresh: data.refresh === 0 ? 0 : data.refresh ? data.refresh : "2",
				hospitalNumber: data.hospitalNumber ? data.hospitalNumber : "病历号",
				hospitalDateTime: data.hospitalDateTime
					? data.hospitalDateTime
					: "申请日期",
				signatureType: data.signatureType ? data.signatureType : "电子签名",
				referralConsultTime: data.referralConsultTime
					? data.referralConsultTime
					: "1",
				referralApplyTime: data.referralApplyTime
					? data.referralApplyTime
					: "1",
				showTranquillizationBlood: data.showTranquillizationBlood || false,
			});
		}
		let params = {
			TYPE: "CONFIGURA",
			PARAM: "GET_MACHINE_LIST",
		};
		let paramsEcho = {
			TYPE: "CONFIGURA",
			PARAM: "GET_CONFIGURATION",
		};
		sendMessage(params); //获取列表
		sendMessage(paramsEcho); //获取配置信息
		receiveMessage((data) => {
			if (data.RETURN_VALUE === "GET_CONFIGURATION") {
				//回显数据
				let list = JSON.parse(data.RETURN_MSG);
				this.setState({
					fileTree: list.monitorPath ? list.monitorPath : "D:\\MACHINE\\",
					fileOutTree: list.outPutPath ? list.outPutPath : "D:\\MACHINE_OUT\\",
					IPAddress: list.ServerIP ? list.ServerIP : "",
					IPPort: list.ServerPort ? list.ServerPort : "",
					equipmentValue: list.machineType ? list.machineType : "",
					EEG_FILE_PATH: list.EEGFilePath ? list.EEGFilePath : "",
				});
			}
			if (data.RETURN_VALUE === "GET_MACHINE_LIST") {
				//配置列表数据
				let list = JSON.parse(data.RETURN_MSG);
				this.setState({
					equipmentList: list,
				});
			}
		});
	}

	getConsulationHospital() {
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		const settingValues = JSON.parse(localStorage.getItem('settingValues')) || {}
		let params = {
			Type: "Remote",
			hospital_Code: userInfo.HOSPITAL_CODE
		}
		remoteHospitalList(params).then((res) => {
			if (res && res.Status === 1) {
				const applyData = res.Result
				// let consulationList = applyData.filter(item => item.CONSULTATION_HOSPITAL_CODE !== userInfo.HOSPITAL_CODE)
				// 过滤医院列表是否包含本地存储的会诊医院
				let result = applyData.some(item => item.CONSULTATION_HOSPITAL_CODE === settingValues.automaticConsult)
				if (!result) {
					this.props.form.setFieldsValue({ automaticConsult: '' })
				}
				this.setState({
					consulationList: applyData.filter(item => item.IS_ENABLED === 1)
				})
			} else {
				requestErrorLog('', '系统设置-本地配置-获取会诊医院报错', 0, true)
			}
		})
	}

	handleConsultValue = (value) => {
		this.setState({
			automaticConsultCode: value,
		});
	}

	handleRemoteCheckbox = (checkedValues) => {
		this.setState({
			automaticApplyCode: checkedValues,
		})
	}

	handleCompleteCheckbox = (checkedValues) => {
		this.setState({
			automaticCompleteCode: checkedValues,
		})
	}

	handleMsgCheckbox = (value) => {
		this.setState({
			msgType: value,
		});
	};
	handleWaitImproved = (e) => {
		this.setState({
			waitImproved: e.target.checked,
		});
	};

	handleSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				message.success("保存成功");
				localStorage.setItem("settingValues", JSON.stringify(values));
			}
		});
		this.setEquipmentMessage();
		this.props.getMessageFn();
	};
	//保存配置信息
	setEquipmentMessage = () => {
		let params = {
			TYPE: "CONFIGURA",
			PARAM: "SET_CONFIGURTION",
			MACHINE_TYPE: this.state.equipmentValue,
			MACHINE_OUT: this.state.fileOutTree,
			MACHINE: this.state.fileTree,
			SERVER_IP: this.state.IPAddress,
			SERVER_PORT: this.state.IPPort,
			EEG_FILE_PATH: this.state.EEG_FILE_PATH,
		};
		sendMessage(params);
	};

	getData = (type, obj) => {
		if (type === 1) {
			this.setState({
				fileTree: obj.target.value,
			});
		} else if (type === 2) {
			this.setState({
				fileOutTree: obj.target.value,
			});
		} else if (type === 3) {
			this.setState({
				IPAddress: obj.target.value,
			});
		} else if (type === 4) {
			this.setState({
				IPPort: obj.target.value,
			});
		} else if (type === 5) {
			this.setState({
				EEG_FILE_PATH: obj.target.value,
			});
		}
	};
	componentWillUnmount() {
		this.setState = () => false;
	}
	//保存心电图机选择
	equipmentSetting = (value) => {
		this.setState({
			equipmentValue: value,
		});
	};

	render() {
		const { getFieldDecorator } = this.props.form;
		const {
			msgType,
			apply,
			consulation,
			printingType,
			refresh,
			hospitalNumber,
			hospitalDateTime,
			signatureType,
			equipmentList,
			equipmentValue,
			referralApplyTime,
			referralConsultTime,
			waitImproved,
			showTranquillizationBlood,
			remoteApplyList,
			consulationList,
			automaticApply,
			automaticCompleteConsult
		} = this.state;
    console.log(apply,'默认查询天数')
		const data = JSON.parse(localStorage.getItem("settingValues"));
		const messageOptions = ["有新会诊到达消息", "会诊完成消息"];
		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 8 },
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 16 },
			},
		};
		return (
			<>
				<Form {...formItemLayout} className="formWrap">
					<Divider orientation="left">打印医院名称</Divider>
					<FormItem label="打印医院名称">
						{getFieldDecorator("printingType", { initialValue: printingType })(
							<Select style={{ width: "100px" }}>
								<Option value="申请医院">申请医院</Option>
								<Option value="会诊医院">会诊医院</Option>
							</Select>
						)}
					</FormItem>

					<Divider orientation="left">上传模式</Divider>
					<FormItem label="自发申请会诊">
						{getFieldDecorator("automaticApply", { initialValue: automaticApply })(
							<Checkbox.Group
								options={remoteApplyList}
								onChange={this.handleRemoteCheckbox}
							/>
						)}
					</FormItem>
					<FormItem label="默认自发会诊医院">
						{getFieldDecorator("automaticConsult", { initialValue: data.automaticConsult })(
							<Select placeholder="请选择会诊医院" onChange={this.handleConsultValue} style={{ width: '400px', marginBottom: '20px' }}>
								{consulationList.map((item) => (
									<Option key={item.CONSULTATION_HOSPITAL_CODE} value={item.CONSULTATION_HOSPITAL_CODE}>{item.CONSULTATION_HOSPITAL_NAME}</Option>
								))}
							</Select>
						)}
					</FormItem>

					<FormItem label="自发完成会诊">
						{getFieldDecorator("automaticCompleteConsult", { initialValue: automaticCompleteConsult })(
							<Checkbox.Group
								options={remoteApplyList}
								onChange={this.handleCompleteCheckbox}
							/>
						)}
					</FormItem>

					<Divider orientation="left">接收消息类型</Divider>
					<FormItem label="接收消息类型">
						{getFieldDecorator("msgType", { initialValue: msgType })(
							<Checkbox.Group options={messageOptions} onChange={this.handleMsgCheckbox}>

							</Checkbox.Group>
						)}
					</FormItem>

					<Divider orientation="left">默认查询天数</Divider>
					<Col span={11} style={{ paddingLeft: 150 }}>
						<FormItem label="远程申请">
							{getFieldDecorator("apply", { initialValue: apply })(
								<InputNumber min={1} />
							)}
						</FormItem>
						<FormItem label="转诊申请">
							{getFieldDecorator("referralApplyTime", {
								initialValue: referralApplyTime,
							})(<InputNumber min={1} />)}
						</FormItem>
					</Col>
					<Col span={12}>
						<FormItem label="远程会诊">
							{getFieldDecorator("consulation", { initialValue: consulation })(
								<InputNumber min={1} />
							)}
						</FormItem>
						<FormItem label="转诊会诊">
							{getFieldDecorator("referralConsultTime", {
								initialValue: referralConsultTime,
							})(<InputNumber min={1} />)}
						</FormItem>
					</Col>

					<Divider orientation="left">自动刷新</Divider>
					<FormItem label="自动刷新时间间隔(分钟)">
						{getFieldDecorator("refresh", { initialValue: refresh })(
							<InputNumber min={0} />
						)}
					</FormItem>

					<Divider orientation="left">默认查询号/日期</Divider>
					<Col span={12} push={3}>
						<FormItem label="选择查询号">
							{getFieldDecorator("hospitalNumber", {
								initialValue: hospitalNumber,
							})(
								<Select style={{ width: "120px" }}>
									<Option value="病历号">病历号</Option>
									<Option value="住院号">住院号</Option>
									<Option value="门诊号">门诊号</Option>
									<Option value="申请号">申请号</Option>
								</Select>
							)}
						</FormItem>
					</Col>
					<Col span={12} push={0}>
						<FormItem label="选择查询日期">
							{getFieldDecorator("hospitalDateTime", {
								initialValue: hospitalDateTime,
							})(
								<Select style={{ width: "140px" }}>
									<Option value="申请日期">创建日期</Option>
									<Option value="远程申请日期">申请会诊日期</Option>
									<Option value="检查日期">检查日期</Option>
									<Option value="报告日期">报告日期</Option>
									<Option value="完成会诊日期">完成会诊日期：</Option>
								</Select>
							)}
						</FormItem>
					</Col>
					<Divider orientation="left">签名类型</Divider>
					<FormItem label="选择签名类型：">
						{getFieldDecorator("signatureType", {
							initialValue: signatureType,
						})(
							<Select style={{ width: "200px" }}>
								<Option value="电子签名">电子签名</Option>
								<Option value="打印签名">打印签名</Option>
								<Option value="手动签名">手动签名</Option>
							</Select>
						)}
					</FormItem>
					<Divider orientation="left">静息心电设备配置</Divider>
					<FormItem label="心电图机选择">
						<Select
							style={{ width: "345px" }}
							onChange={this.equipmentSetting}
							value={equipmentValue}>
							{equipmentList &&
								equipmentList.map((item) => (
									<Option value={item.CODE} key={item.CODE}>
										{item.NAME}
									</Option>
								))}
						</Select>
					</FormItem>
					<FormItem label="ECG文件目录">
						<Input
							style={{ width: "345px" }}
							value={this.state.fileTree}
							onChange={this.getData.bind(this, 1)}
						/>
					</FormItem>
					<FormItem label="ECG文件输出目录">
						<Input
							style={{ width: "345px" }}
							value={this.state.fileOutTree}
							onChange={this.getData.bind(this, 2)}
						/>
					</FormItem>
					<FormItem label="脑电监控地址">
						<Input
							style={{ width: "345px" }}
							value={this.state.EEG_FILE_PATH}
							onChange={this.getData.bind(this, 5)}
						/>
					</FormItem>
					<FormItem label="服务IP">
						<Input
							style={{ width: "178px" }}
							value={this.state.IPAddress}
							onChange={this.getData.bind(this, 3)}
						/>
						<span style={{ marginLeft: "20px" }}>端口：</span>
						<Input
							style={{ width: "105px" }}
							value={this.state.IPPort}
							onChange={this.getData.bind(this, 4)}
						/>
					</FormItem>
					<Divider orientation="left">显示隐藏列表</Divider>
					<FormItem label="显示待完善列表">
						{getFieldDecorator("waitImproved", { initialValue: waitImproved })(
							<Checkbox
								checked={waitImproved}
								onChange={this.handleWaitImproved}
							/>
						)}
					</FormItem>
					<FormItem label="显示常规血压列表">
						{getFieldDecorator("showTranquillizationBlood", {
							initialValue: showTranquillizationBlood,
							valuePropName: "checked",
						})(<Checkbox />)}
					</FormItem>
					<Form.Item wrapperCol={{ offset: 20 }}>
						<Button type="primary" onClick={this.handleSubmit}>
							保存
						</Button>
					</Form.Item>
				</Form>
			</>
		);
	}
}

export default Form.create({})(settingConfig);
